type ValueOf<T> = T[keyof T];

export const EDITORIAL_SIMPLE_TEXT_CLASS_COLOR_VALUES = ['Neutral 10', 'Neutral 40'] as const;
export const EDITORIAL_HEADING_TYPE_VALUES = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;
export const EDITORIAL_HEADING_CLASS_VALUES = [
    'Heading Display L',
    'Heading Display M',
    'Heading Display S',
    'Heading Headline L',
    'Heading Headline M',
    'Heading Headline S',
    'Heading Title L',
    'Heading Title M',
    'Title L',
    'Title M',
    'Body Copy L Bold',
] as const;

export const EDITORIAL_SIMPLE_TEXT_CLASS_VALUES = ['Body Copy L', 'Body Copy M', 'Body Copy S'] as const;

export type EditorialHeadingTypeId = (typeof EDITORIAL_HEADING_TYPE_VALUES)[number];
export type EditorialHeadingClassId = (typeof EDITORIAL_HEADING_CLASS_VALUES)[number];
export type EditorialSimpleTextClassId = (typeof EDITORIAL_SIMPLE_TEXT_CLASS_VALUES)[number];
export type EditorialSimpleTextClassColorId = (typeof EDITORIAL_SIMPLE_TEXT_CLASS_COLOR_VALUES)[number];

export const DEFAULT_EDITORIAL_HEADING_TYPE = 'h3' satisfies EditorialHeadingTypeId;
export const DEFAULT_EDITORIAL_HEADING_CLASS_ID = 'Heading Headline M' satisfies EditorialHeadingClassId;
export const DEFAULT_HERO_HEADING_TYPE = 'h2' satisfies EditorialHeadingTypeId;
export const DEFAULT_HERO_HEADING_CLASS_ID = 'Heading Display M' satisfies EditorialHeadingClassId;
export const DEFAULT_EDITORIAL_SIMPLE_TEXT_CLASS_ID = 'Body Copy M' satisfies EditorialSimpleTextClassId;
export const DEFAULT_EDITORIAL_SIMPLE_TEXT_CLASS_COLOR_ID = 'Neutral 10' satisfies EditorialSimpleTextClassColorId;

export const EDITORIAL_HEADING_CLASS_MAP = {
    'Heading Display L': 'heading-display-l',
    'Heading Display M': 'heading-display-m',
    'Heading Display S': 'heading-display-s',
    'Heading Headline L': 'heading-headline-l',
    'Heading Headline M': 'heading-headline-m',
    'Heading Headline S': 'heading-headline-s',
    'Heading Title L': 'heading-title-l',
    'Heading Title M': 'heading-title-m',
    'Title L': 'title-l',
    'Title M': 'title-m',
    'Body Copy L Bold': 'body-copy-l-bold',
} as const satisfies Record<EditorialHeadingClassId, string>;

export const EDITORIAL_SIMPLE_TEXT_CLASS_MAP = {
    'Body Copy L': 'body-copy-l',
    'Body Copy M': 'body-copy-m',
    'Body Copy S': 'body-copy-s',
} as const satisfies Record<EditorialSimpleTextClassId, string>;

export const EDITORIAL_SIMPLE_TEXT_CLASS_COLOR_MAP = {
    'Neutral 10': 'text-neutral-10',
    'Neutral 40': 'text-neutral-40',
} as const satisfies Record<EditorialSimpleTextClassColorId, string>;
export type EditorialHeadingClassName = ValueOf<typeof EDITORIAL_HEADING_CLASS_MAP>;
export type EditorialSimpleTextClassName = ValueOf<typeof EDITORIAL_SIMPLE_TEXT_CLASS_MAP>;
export type EditorialSimpleTextClassColorClassName = ValueOf<typeof EDITORIAL_SIMPLE_TEXT_CLASS_COLOR_MAP>;
export function resolveEditorialHeadingClass(classId?: EditorialHeadingClassId): EditorialHeadingClassName {
    return classId
        ? EDITORIAL_HEADING_CLASS_MAP[classId]
        : EDITORIAL_HEADING_CLASS_MAP[DEFAULT_EDITORIAL_HEADING_CLASS_ID];
}

export function resolveEditorialSimpleTextClass(classId?: EditorialSimpleTextClassId): EditorialSimpleTextClassName {
    return classId
        ? EDITORIAL_SIMPLE_TEXT_CLASS_MAP[classId]
        : EDITORIAL_SIMPLE_TEXT_CLASS_MAP[DEFAULT_EDITORIAL_SIMPLE_TEXT_CLASS_ID];
}

export function resolveEditorialSimpleTextClassColor(
    classColorId?: EditorialSimpleTextClassColorId
): EditorialSimpleTextClassColorClassName {
    return classColorId
        ? EDITORIAL_SIMPLE_TEXT_CLASS_COLOR_MAP[classColorId]
        : EDITORIAL_SIMPLE_TEXT_CLASS_COLOR_MAP[DEFAULT_EDITORIAL_SIMPLE_TEXT_CLASS_COLOR_ID];
}

export function resolveEditorialHeadingType(headingTypeId?: string): EditorialHeadingTypeId {
    if (headingTypeId && (EDITORIAL_HEADING_TYPE_VALUES as readonly string[]).includes(headingTypeId)) {
        return headingTypeId as EditorialHeadingTypeId;
    }

    return DEFAULT_EDITORIAL_HEADING_TYPE;
}
